import React, { FC, PropsWithChildren, ReactNode } from 'react'
import { Hidden } from '@hermes/web-components'
import { FactsContainer, GridTemplate, LastRowsTemplate } from './styles'

type FactsProps = {
  children: NonNullable<ReactNode>
}

type GridProps = {
  children: NonNullable<ReactNode>
  columnCount: number
}

interface FactsComponent extends FC<FactsProps> {
  Item: FC<PropsWithChildren>
}

const Grid = ({ children, columnCount }: GridProps) => {
  const items = React.Children.toArray(children)
  const lastItemsCount = items.length % columnCount
  const gridItems = items.slice(0, items.length - lastItemsCount)
  const lastItems = items.slice(items.length - lastItemsCount, items.length)

  return (
    <FactsContainer style={{ color: '#4C5870' }}>
      <GridTemplate style={{ gridTemplateColumns: `repeat(${columnCount}, 1fr)` }}>{gridItems}</GridTemplate>
      {lastItems.length ? (
        <>
          <Hidden implementation="css" mdDown>
            <LastRowsTemplate style={{ gap: '32px', padding: '0 32px' }}>
              {lastItems.map((item, key) => (
                <div style={{ maxWidth: `calc(100% / ${columnCount})` }} key={key}>
                  {item}
                </div>
              ))}
            </LastRowsTemplate>
          </Hidden>
          <Hidden implementation="css" mdUp>
            <LastRowsTemplate style={{ gap: '32px' }}>{lastItems}</LastRowsTemplate>
          </Hidden>
        </>
      ) : null}
    </FactsContainer>
  )
}

const Facts: FactsComponent = ({ children }) => {
  const items = React.Children.toArray(children)
  return <Grid columnCount={items.length > 5 ? 2 : 3}>{children}</Grid>
}

Facts.Item = ({ children }) => {
  return <div style={{ display: 'flex', alignItems: 'flex-start', gap: '12px' }}>{children}</div>
}

export default Facts
